import { createVNode as o, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ResourceManageFilledStandard.js";
import l from "../components/PfIcon.js";
const e = (r, a) => {
  const t = {
    ...r,
    ...a.attrs
  };
  return o(l, n(t, {
    icon: d
  }), null);
};
e.displayName = "ResourceManageFilledStandard";
e.inheritAttrs = !1;
export {
  e as default
};
